import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { isNativeShell } from '../../utils/distribution';

/**
 * Full-screen offline state for Capacitor shells (Apple 4.2 / plan native-feature-set).
 * Avoids a raw WebView browser error page when connectivity drops mid-session.
 */
const NativeOfflineOverlay: React.FC = () => {
  const [offline, setOffline] = useState(
    () => typeof navigator !== 'undefined' && !navigator.onLine,
  );

  useEffect(() => {
    if (!isNativeShell()) return undefined;

    const syncOffline = () => setOffline(!navigator.onLine);
    window.addEventListener('online', syncOffline);
    window.addEventListener('offline', syncOffline);
    return () => {
      window.removeEventListener('online', syncOffline);
      window.removeEventListener('offline', syncOffline);
    };
  }, []);

  if (!isNativeShell() || !offline) {
    return null;
  }

  return (
    <Box
      role="alertdialog"
      aria-labelledby="native-offline-title"
      aria-describedby="native-offline-body"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 10,
        bgcolor: '#0d1320',
        color: '#e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: 420,
          width: '100%',
          textAlign: 'center',
          bgcolor: '#111827',
          border: '1px solid #374151',
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography id="native-offline-title" variant="h6" sx={{ color: '#d1fae5', mb: 1.5 }}>
          Unable to reach Qixit Mail
        </Typography>
        <Typography id="native-offline-body" variant="body2" sx={{ color: '#9ca3af', mb: 2 }}>
          Check your internet connection and try again.
        </Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </Box>
    </Box>
  );
};

export default NativeOfflineOverlay;
